module.exports = "<span ng-bind=\"$ctrl.ngModel\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\" ng-class=\"$ctrl.inputClass\" ng-model=\"$ctrl.ngModel\" ng-options=\"opt for opt in $ctrl.states\" ng-if=\"$ctrl.mode === 'edit'\"></select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/state.picker.html
// module id = 729
// module chunks = 0